export default __webpack_public_path__ + "static/media/show-cup-1.1f3032c3.webp";